module.exports = __webpack_public_path__ + "static/media/gymnastics.963be74b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hero-backgrounds/gymnastics.jpg
// module id = 691
// module chunks = 0